import request from "../plugins/axios";


export function trafficRecharge(data) {
	return request({
		url: '/scrm/tenantRedMoneyEwmRechargeApplyLogAdd',
		method: 'POST',
		data
	})
}

export function trafficRechargeList(data) {
    return request({
        url: '/scrm/tenantRedMoneyEwmRechargeApplyLogList',
        method: 'POST',
        data
    })
}

export function trafficUploadImage(data) {
    return request({
        url: '/scrm/uploadImgCommon',
        method: 'POST',
        data
    })
}